import React, { useEffect,useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { agentSliceAction } from "../../../store/agentSlice"
import { chatSliceAction } from "../../../store/chatSlice"
import { millisecondsToHMS } from "../../../utils/utils"

const EmailStatus = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const agentObj = useSelector((state: any) => { return state.agentSlice.agentObj })
    const [agentCurrentState, setAgentCurrentState] = useState<any>("");
    const contactObjEmail = useSelector((state:any)=>{return state.contactSlice.EmailContactObject});
    const newIncomingEmail = useSelector((state:any)=>{return state.chatSlice.newIncomingEmail});
    const isEmailMissed = useSelector((state:any)=>{return state.chatSlice.isEmailMissed});
    const isItRejected = useSelector((state:any)=>{return state.chatSlice.isEmailRejected});
    const missedTimeout = useSelector((state:any)=>{return state.chatSlice.newIncomingChatMissedTimer});
    const [stateDuration, setStateDuration] = React.useState("00:00:00");
    const [callbackStatus, setCallbackStatus] = useState<any>("")

    useEffect(() => {
        
        if (agentObj) {
            setAgentCurrentState(agentObj.getState().name)
            agentObj?.onRefresh(() => {
                setAgentCurrentState(agentObj.getState().name)
                if (agentObj?.getContacts().length === 0) {
                    setCallbackStatus("")
                }
            })
        }




        let interval: any;
        if(contactObjEmail) {
            try {
                interval = setInterval(() => {
                    try {
                        let durationInMillis = contactObjEmail?.getStatusDuration();
                        if(missedTimeout !== "0") {
                            if((isEmailMissed || isItRejected) && durationInMillis > (missedTimeout) * 1000){
                                onClearChat();
                                dispatch(chatSliceAction.changeisEmailRejected({isEmailRejected: false}));
                                dispatch(chatSliceAction.changeisEmailMissed({isEmailMissed: false}));
                            }
                        }
                        let hms = millisecondsToHMS(durationInMillis);
                        setStateDuration(hms);
                    } catch (err) {
                        console.log(err);
                        clearInterval(interval);
                    }
                }, 1000);
            } catch (error) {
                clearInterval(interval);
            }
        }
        return()=>{
            clearInterval(interval);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newIncomingEmail, isEmailMissed, isItRejected, contactObjEmail,agentObj]);

    const onClearChat = () => {
        try{
            contactObjEmail.clear({
            success:function(){
                console.log("ConnectionComponent::onClear::Chat Clear Succesfully.");
			},
			failuer:function(err:any){
				console.log("ConnectionComponent::onClear::Error in Chat Clear."+ err);				
			}			
		});	}catch(e){
            alert(e)
        }		
	}

    const redirectToChats = () => {
        navigate("/emails");
    }

    return (
        <React.Fragment>
            {(newIncomingEmail) &&
                <div className="ongoing-call bg-success">
                    <div className="call-number">
                        <p onClick={() => redirectToChats()} className="text-white m-0 fw-bold">Incoming Email <span className="ongoing-time ms-5">{stateDuration}</span></p>
                    </div>
                </div>
            }
            {(isEmailMissed && (contactObjEmail?.getAttributes()?.ChannelTwo?.value ==="Email") ) &&
                <div className="ongoing-call bg-danger">
                    <div className="call-number">
                        <p className="text-white m-0 fw-bold">Missed Email <span className="ongoing-time ms-5">{stateDuration}</span></p>
                    </div>
                    <div className="ms-2">
                        <button onClick={() => { onClearChat(); dispatch(chatSliceAction.changeisEmailMissed({isEmailMissed: false}));dispatch(chatSliceAction.changeisEmailRejected({isEmailRejected: false})); }} className="clear-btn">Clear contact</button>
                    </div>
                </div>
            }{(isItRejected && (contactObjEmail?.getAttributes()?.ChannelTwo?.value ==="Email")) &&
                <div className="ongoing-call bg-danger">
                    <div className="call-number">
                        <p className="text-white m-0 fw-bold">Rejected Email <span className="ongoing-time ms-5">{stateDuration}</span></p>
                    </div>
                    <div className="ms-2">
                        <button onClick={() => { 
                            onClearChat();
                            dispatch(chatSliceAction.changeisEmailMissed({isEmailMissed: false})); 
                            dispatch(chatSliceAction.changeisEmailRejected({isEmailRejected: false}));
                            }} className="clear-btn">Clear contact</button>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}
export default EmailStatus;